import { ArrowRightIcon } from '@phosphor-icons/react';

interface OAuthButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
}

export function OAuthButton({ icon, label, onClick }: OAuthButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group flex h-13 w-full cursor-pointer items-center justify-between rounded-xl bg-brand px-6 text-sm font-semibold text-white shadow-(--shadow-card) transition-colors duration-150 hover:bg-brand-hover active:bg-brand-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      {icon}
      <span>{label}</span>
      <ArrowRightIcon
        size={18}
        weight="bold"
        className="text-white/70 transition-transform duration-200 group-hover:translate-x-0.5"
      />
    </button>
  );
}
